<template>
  <div class="card" id="cardOrcamento">
    <b-card-header
      :header="header"
      header-text-variant="white"
      header-tag="header"
      :style="style1"
    />
    <b-card class="cardBody" v-if="this.pedidosOrcamento.pedidos">
      <b-card-text class="table" v-if="this.pedidosOrcamento.pedidos.length > 0">
          <b-table bordered striped :items="pedidosOrcamento.pedidos" :fields="fields" />
      </b-card-text>
      <span v-else>Não há itens para exibir nesta sessão</span>
    </b-card>
  </div>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    props: {
      style1: '',
      title: '',
      header: '',
      pCardPedidosEmOrcamentoValues: {pedidos: []}
    },
    computed: {
      ...mapState({
        cor: state => {
          const { cor } = state.cor
          return {
            'background-color': cor
          }
        }
      })
    },
    watch: {
      pCardPedidosEmOrcamentoValues: function (newVal, oldVal) { // watch it
        this.pedidosOrcamento = newVal
      }
    },
    data () {
      return {
        pedidosOrcamento: [],
        fields: [
          {
            key: 'id',
            label: 'Pedido',
            sortable: true
          },
          {
            key: 'fantasia',
            label: 'Cliente',
            sortable: true,
            formatter: this.toCapitalize
          },
          {
            key: 'emissao',
            label: 'Emissão',
            sortable: true
          },
          {
            key: 'totalPedido',
            label: 'Valor',
            sortable: true,
            class: 'txtRight',
            formatter: this.formatterValue
          }
        ]
      }
    },
    created () {
      // console.log('card pedidos em orcamento criado')
    },
    mounted () {
      // console.log('card pedidos em orcamento mount')
      this.pedidosOrcamento = this.pCardPedidosEmOrcamentoValues
    },
    methods: {
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      formatterValue: valor => {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    }
  }
</script>
<style scoped>
   /*.table{*/
    /*overflow-y: scroll;*/
    /*position: relative;*/
    /*min-height: 82px;*/
    /*max-height: 210px;*/
    /*font-size: 14px;*/
  /*}*/
   .table {
     overflow-y: auto;
     max-height: 210px;
     font-size: 14px;
   }




</style>




// WEBPACK FOOTER //
// src/components/items/CardPedidosOrcamentoVue.vue